<template>
  <div class="mt-4">
    <BaseInput v-model="queryText" />
  </div>

  <div class="my-3">
    <BaseTable
      :fields="tableFields"
      :items="budgetItemsTemplates"
      :is-loading="isLoading"
      :error="isError ? error : null"
      :paginate="true"
      :next-page="nextPage"
      :prev-page="prevPage"
      :page="currentPage"
      :total-records="totalRecords"
      :total-pages="totalPages"
      :number-per-page="numPerPage"
    >
      <template #title-data="{ row }">
        <div class="flex items-center">
          <BaseCheckbox
            v-model="selectedItems"
            class="-mb-4"
            :value="row"
          />
          <span class="ml-2">{{ row.title }}</span>
        </div>
      </template>

      <template #cost-header="{ column }">
        <span class="text-center block">{{ column.label }}</span>
      </template>

      <template #cost-data="{ row }">
        <span class="text-center block">{{ currency(row.cost) }}</span>
      </template>
    </BaseTable>
  </div>
  <div>
    <hr class="my-4">
    <div class="flex justify-end gap-2 my-3 mr-4 sm:mr-6 -mb-4 sm:-mb-6">
      <BaseButton
        variant="base"
        text="Cancel"
        @click="rowSelected([])"
      />

      <BaseButton
        variant="primary"
        text="Ok"
        @click="rowSelected(selectedItems)"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { ref, watch } from 'vue'
import BudgetTemplateService from '@/services/BudgetTemplateService'
import { useSearchablePagination } from '@/composables/useSearchablePagination'
import BaseTable from '@/components/base/BaseTable.vue'
import { currency } from '@/utils'
import BaseCheckbox from '@/components/base/BaseCheckbox.vue'
import BaseButton from '@/components/base/BaseButton.vue'
import BaseInput from '@/components/base/BaseInput.vue'

const tableFields = [
  { key: 'title', label: 'Title' },
  { key: 'cost', label: 'Cost' }
]

const emit = defineEmits(['onBugetTemplateSelected'])
const budgetTemplateService = new BudgetTemplateService()
const numPerPage = ref(15)

const selectedItems = ref([])

const {
  results: budgetItemsTemplates,
  isPending: isLoading,
  isError,
  error,
  queryText,
  search,
  currentPage,
  totalPages,
  totalRecords,
  nextPage,
  prevPage,
} = useSearchablePagination({
  indexName: 'budgetItems',
  service: budgetTemplateService,
  numPerPage: numPerPage.value,
  defaultOrderBy: 'title',
  defaultOrderDir: 'asc'
})

watch(queryText, (newQuery) => {
  search(newQuery)
}, { immediate: true })

const rowSelected = (items) => {
  emit('onBugetTemplateSelected', items)
}
</script>
